import { createSelector } from 'reselect';
import { AppState } from '../createStore';

const checkoutSelector = (state: AppState) => state.checkout;

export const selectIsFutureOrder = createSelector([checkoutSelector], (checkout: AppState['checkout']) => {
  return !!checkout?.dispatch?.time;
});
